import React from 'react';
import { useState, useEffect } from "react";
import SectionConnexion from "./SectionConnexion";
import SectionTracking from './SectionTracking';
import Modal from 'react-bootstrap/Modal';
import '../styles/Footer.scss';
import useUserSession from './useUserSession';
import { getToken } from './sessionManager';
import { useTranslation } from 'react-i18next';

import { firebaseSignOut } from './firebaseConfig';

function Footer({data, error}) {
    const { user, setUser } = useUserSession();
    const { t } = useTranslation();
    const [isCon, setIsCon]= useState(false);

    useEffect(() => {
      if (isCon) {
        handleModalHide()
      }
      setIsCon(!!user);
    }, [user]);
    const [modalShow, setModalShow] = useState(false);
    const [modalShow2, setModalShow2] = useState(false);
    const [showTerms, setShowTerms] = useState(false);
    const [showLegal, setShowLegal] = useState(false);
    const [showAbout, setShowAbout] = useState(false);
    const [showContact, setShowContact] = useState(false);
    const [contactObject, setContactObject] = useState('');
    const [contactMessage, setContactMessage] = useState('');
    const [contactSubmitting, setContactSubmitting] = useState(false);
    const [contactSuccess, setContactSuccess] = useState(false);
    const [contactError, setContactError] = useState('');

    const handleContactClose = () => {
        setShowContact(false);
        setContactObject('');
        setContactMessage('');
        setContactSuccess(false);
        setContactError('');
    };

    const handleContactSend = async () => {
        if (!contactObject.trim() || !contactMessage.trim()) {
            setContactError(t('contact.fillAllFields'));
            return;
        }
        setContactError('');
        setContactSubmitting(true);
        try {
            const token = getToken();
            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/user/contactus`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    message: contactMessage,
                    object: contactObject,
                    name: user?.name || '',
                    mail: user?.email || ''
                })
            });
            const data = await res.json();
            if (data.status === 0 || res.ok) {
                setContactObject('');
                setContactMessage('');
                setContactSuccess(true);
            } else {
                setContactError(t('contact.sendError'));
            }
        } catch (err) {
            setContactError(t('contact.sendError'));
        } finally {
            setContactSubmitting(false);
        }
    };

    const handleModalShow = () => {
        setModalShow(true)
    };
    const handleModalHide = () => {
        setModalShow(false)
    };
    const handleModalShow2 = () => {
        setModalShow2(true)
    };
    const handleModalHide2 = () => {
        setModalShow2(false)
    };

    const handleSignOut = async () => {
      try {
        localStorage.clear();
        setUser(null);
        await firebaseSignOut();
      } catch (error) {
        // Error silenced
      }
    };

  return (
    <>
        <div className='Footer'>
            <div className='Footer_inside'>
                <div className='Footer_inside1'>
                    <div className='Footer_inside1_a'>
                        <div className='Footer_inside1_c_span Footer_inside1_login' onClick={() => setShowAbout(true)}><span>{t('footer.about')}</span> <span className='fw-bold'>{t('footer.grouping')}</span></div>
                        <span className='Footer_inside1_c_span Footer_inside1_login' onClick={() => setShowContact(true)}>{t('footer.contactUs')}</span>
                    </div>
                    <div className='Footer_inside1_b'>
                    {isCon ?
                        (<span  className='Footer_inside1_login Footer_inside1_c_span' onClick={handleSignOut}>{t('nav.logout')}</span>)
                        :
                        (<span  className='Footer_inside1_login Footer_inside1_c_span' onClick={handleModalShow}>{t('footer.signUp')}</span>)
                    }
                        <span className='Footer_inside1_login Footer_inside1_c_span' onClick={handleModalShow}>{t('footer.addAd')}</span>
                        <span  className='Footer_inside1_login Footer_inside1_c_span' onClick={handleModalShow2}>{t('footer.onMap')}</span>
                    </div>
                    <div className='Footer_inside1_c'>
                        <span className='Footer_inside1_c_span Footer_inside1_login' onClick={() => setShowTerms(true)}>{t('footer.terms')}</span>
                        <span className='Footer_inside1_c_span Footer_inside1_login' onClick={() => setShowLegal(true)}>{t('footer.legal')}</span>
                    </div>

                </div>
                <div className='Footer_inside2'>
                    <span>{t('footer.copyright')}</span>
                </div>

            </div>
        </div>
        {!isCon &&
            <SectionConnexion show={modalShow} onHide={handleModalHide}/>
        }
        <SectionTracking
            show={modalShow2}
            onHide={handleModalHide2}
        />

        {/* Modal Conditions d'utilisation */}
        <Modal show={showTerms} onHide={() => setShowTerms(false)} size="lg" centered scrollable className="FooterLegalModal">
          <Modal.Header closeButton>
            <Modal.Title>{t('footer.terms')}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="FooterLegalModal_body">
            <p className="FooterLegalModal_updated">{t('legal.lastUpdated')}</p>

            <h5>1. {t('legal.terms.acceptTitle')}</h5>
            <p>{t('legal.terms.acceptText')}</p>

            <h5>2. {t('legal.terms.descriptionTitle')}</h5>
            <p>{t('legal.terms.descriptionText')}</p>

            <h5>3. {t('legal.terms.accountTitle')}</h5>
            <p>{t('legal.terms.accountText')}</p>

            <h5>4. {t('legal.terms.adsTitle')}</h5>
            <p>{t('legal.terms.adsText')}</p>

            <h5>5. {t('legal.terms.responsibilityTitle')}</h5>
            <p>{t('legal.terms.responsibilityText')}</p>

            <h5>6. {t('legal.terms.messagingTitle')}</h5>
            <p>{t('legal.terms.messagingText')}</p>

            <h5>7. {t('legal.terms.ipTitle')}</h5>
            <p>{t('legal.terms.ipText')}</p>

            <h5>8. {t('legal.terms.liabilityTitle')}</h5>
            <p>{t('legal.terms.liabilityText')}</p>

            <h5>9. {t('legal.terms.terminationTitle')}</h5>
            <p>{t('legal.terms.terminationText')}</p>

            <h5>10. {t('legal.terms.modificationTitle')}</h5>
            <p>{t('legal.terms.modificationText')}</p>

            <h5>11. {t('legal.terms.lawTitle')}</h5>
            <p>{t('legal.terms.lawText')}</p>

            <h5>12. {t('legal.terms.contactTitle')}</h5>
            <p>{t('legal.terms.contactText')}</p>
          </Modal.Body>
        </Modal>

        {/* Modal À propos de Grouping */}
        <Modal show={showAbout} onHide={() => setShowAbout(false)} size="lg" centered scrollable className="FooterLegalModal">
          <Modal.Header closeButton>
            <Modal.Title>{t('about.title')}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="FooterLegalModal_body">
            <h5>{t('about.missionTitle')}</h5>
            <p>{t('about.missionText')}</p>

            <h5>{t('about.howTitle')}</h5>
            <p>{t('about.howText')}</p>

            <h5>{t('about.servicesTitle')}</h5>
            <ul>
              <li>{t('about.service1')}</li>
              <li>{t('about.service2')}</li>
              <li>{t('about.service3')}</li>
              <li>{t('about.service4')}</li>
              <li>{t('about.service5')}</li>
            </ul>

            <h5>{t('about.valuesTitle')}</h5>
            <p><strong>{t('about.value1Title')}</strong> — {t('about.value1Text')}</p>
            <p><strong>{t('about.value2Title')}</strong> — {t('about.value2Text')}</p>
            <p><strong>{t('about.value3Title')}</strong> — {t('about.value3Text')}</p>

            <h5>{t('about.platformsTitle')}</h5>
            <p>{t('about.platformsText')}</p>
          </Modal.Body>
        </Modal>

        {/* Modal Nous contacter */}
        <Modal show={showContact} onHide={handleContactClose} size="lg" centered scrollable className="FooterLegalModal FooterContactModal">
          <Modal.Header closeButton>
            <Modal.Title>{t('contact.title')}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="FooterLegalModal_body">
            {!user ? (
              <div className="FooterContactModal_login">
                <p>{t('contact.loginRequired')}</p>
                <button className="FooterContactModal_loginBtn" onClick={() => { handleContactClose(); handleModalShow(); }}>{t('nav.login')}</button>
              </div>
            ) : contactSuccess ? (
              <div className="FooterContactModal_success">
                <div className="FooterContactModal_success_icon">✓</div>
                <h5>{t('contact.successTitle')}</h5>
                <p>{t('contact.successText')}</p>
                <button className="FooterContactModal_sendBtn" onClick={handleContactClose}>{t('contact.ok')}</button>
              </div>
            ) : (
              <>
                <p>{t('contact.introText')}</p>

                {contactError && (
                  <div className="FooterContactModal_error">
                    <span>{contactError}</span>
                    <button type="button" onClick={() => setContactError('')}>✕</button>
                  </div>
                )}

                <div className="FooterContactModal_field">
                  <label>{t('contact.fromLabel')}</label>
                  <input type="email" value={user?.email || ''} readOnly className="FooterContactModal_input FooterContactModal_input--readonly" />
                </div>

                <div className="FooterContactModal_field">
                  <label>{t('contact.subjectLabel')}</label>
                  <input
                    type="text"
                    value={contactObject}
                    onChange={(e) => setContactObject(e.target.value)}
                    placeholder={t('contact.subjectPlaceholder')}
                    className="FooterContactModal_input"
                  />
                </div>

                <div className="FooterContactModal_field">
                  <label>{t('contact.messageLabel')}</label>
                  <textarea
                    value={contactMessage}
                    onChange={(e) => setContactMessage(e.target.value)}
                    placeholder={t('contact.messagePlaceholder')}
                    className="FooterContactModal_textarea"
                    rows={6}
                  />
                </div>

                <button
                  className="FooterContactModal_sendBtn"
                  onClick={handleContactSend}
                  disabled={contactSubmitting}
                >
                  {contactSubmitting ? t('contact.sending') : t('contact.sendBtn')}
                </button>
              </>
            )}
          </Modal.Body>
        </Modal>

        {/* Modal Mentions légales */}
        <Modal show={showLegal} onHide={() => setShowLegal(false)} size="lg" centered scrollable className="FooterLegalModal">
          <Modal.Header closeButton>
            <Modal.Title>{t('footer.legal')}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="FooterLegalModal_body">
            <p className="FooterLegalModal_updated">{t('legal.lastUpdated')}</p>

            <h5>1. {t('legal.notice.editorTitle')}</h5>
            <p>{t('legal.notice.editorText')}</p>

            <h5>2. {t('legal.notice.hostingTitle')}</h5>
            <p>{t('legal.notice.hostingText')}</p>

            <h5>3. {t('legal.notice.dataTitle')}</h5>
            <p>{t('legal.notice.dataText')}</p>

            <h5>4. {t('legal.notice.cookiesTitle')}</h5>
            <p>{t('legal.notice.cookiesText')}</p>

            <h5>5. {t('legal.notice.ipTitle')}</h5>
            <p>{t('legal.notice.ipText')}</p>

            <h5>6. {t('legal.notice.liabilityTitle')}</h5>
            <p>{t('legal.notice.liabilityText')}</p>

            <h5>7. {t('legal.notice.linksTitle')}</h5>
            <p>{t('legal.notice.linksText')}</p>

            <h5>8. {t('legal.notice.contactTitle')}</h5>
            <p>{t('legal.notice.contactText')}</p>
          </Modal.Body>
        </Modal>
    </>
  )
}

export default Footer